import { testId } from 'ui-components/services/testid-service';

import commonStyle from '../common-style.module.less';
import { CustomsTextInput } from '../customs-text-input';

type DescriptionInputProps = {
  onChange: (value: string | number) => void;
  value?: string;
  'aria-label'?: string;
};

export const DescriptionInput = ({ onChange, value = '', 'aria-label': ariaLabel = '' }: DescriptionInputProps) => {
  return (
    <CustomsTextInput
      {...testId('customs-widget-description-input')}
      aria-label={ariaLabel}
      className={commonStyle['standard-input']}
      onChange={onChange}
      type='text'
      value={value}
    />
  );
};
